import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import { CustomHorizontalChart } from '../../../components/CustomHorizontalChart'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { toggleMediumWidget } from '../DashboardSlice'
import { MediumWidgetsName } from '../types'
import { WidgetWrapper } from '../widgetsComponents'

export const LongShort: FC = () => {
  const { t } = useTranslation()
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()

  const { widgetsData, mediumWidgetsList } = useAppSelector(({ dashboard }) => dashboard)

  const long = widgetsData?.longShortPositions?.long
  const short = widgetsData?.longShortPositions?.short

  const handleCheck = () => {
    dispatch(toggleMediumWidget(MediumWidgetsName.longShort))
  }

  return (
    <WidgetWrapper
      label={t('longShort', 'Long/short')}
      handleCheck={handleCheck}
      isChecked={mediumWidgetsList[MediumWidgetsName.longShort]}
      explanation={t(
        'showsTheProportionBetweenLongPositionsAndShortPositions',
        'Shows the proportion between long positions and short positions',
      )}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        gap={spacing(1.5)}
        width="100%"
        justifyContent="center"
      >
        <Box>
          <Typography component="span" variant="h3">
            {long || '-'}
          </Typography>
        </Box>
        <CustomHorizontalChart positive={long} negative={short} />
        <Box>
          <Typography component="span" variant="h3">
            {short || '-'}
          </Typography>
        </Box>
      </Box>
    </WidgetWrapper>
  )
}
